<template>
  <div class="Information container_w dis_bo">
      <bread-crumb :crumbList='crumbList'></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <div class="clear" style="margin-top:48px;">
        <div class="left">
          <a-menu 
          mode="inline" 
          :open-keys="openKeys"
          :default-selected-keys="selectKeys"
          :selectedKeys="selectedKeys"
          style="width: 256px;border-right: 0;"
          @click="handleClick"
          @openChange="onOpenChange"
          >
            <template v-for="item in informationData">
              <!-- 第一层 -->

              <a-menu-item :key="item.key" v-if="item.childrens.length>0? item.childrens[0].isNode == 'N'?true:false:true">
                {{item.nodeTitle}}
              </a-menu-item>

              <template v-else>
                <a-sub-menu :key="item.key">
                  <span slot="title"><span>{{item.nodeTitle}}</span></span>
                  <template v-for="list in item.childrens">
                    <!-- 第二层 -->
                    
                    <a-menu-item :key="list.key" v-if="list.childrens.length>0?list.childrens[0].isNode == 'N'?true:false:true">
                      {{list.nodeTitle}}
                    </a-menu-item>
                    <template v-else>
                      <a-sub-menu :key="list.key" :title="list.nodeTitle" class="box_show">
                        <span slot="title"><span>{{list.nodeTitle}}</span></span>
                        <template v-for="sublast in list.childrens">
                          <a-menu-item :key="sublast.key">
                            {{sublast.nodeTitle}}
                          </a-menu-item>
                        </template>
                        
                      </a-sub-menu>
                    </template>
                    
                  </template>
                </a-sub-menu>
              </template>

            </template>
          </a-menu>

        </div>


        <div class="right" style="width:832px;">
           <!-- default-active-key="1" -->
           <div v-if="isCollapse">
             <a-collapse :bordered="false" expandIconPosition='right' 
              @change="changeActivekey"
              accordion
              >
                <template #expandIcon="props">
                  <a-icon style="color:#BFBFBF;" type="caret-right" :rotate="props.isActive ? -90 : 90" />
                </template>
                <a-collapse-panel 
                v-for="(item,index) in collapesList" 
                :key="index" 
                :header="item.title"
                :style="customStyle"  
                >
                  <!-- <div v-html="item.htmlMsg"></div> -->
                  <div v-html="collapseHtml"></div>
                </a-collapse-panel>
              </a-collapse>
           </div>
          
          <div v-html="detailHtml" class="information_html_box" v-else></div>
        </div>
        
      </div>
      <!-- <div v-html="detailHtml"></div> -->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader/PageHeader";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
export default {
  components: {
    PageHeader,
    BreadCrumb
  },
  name: "Information",
  data() {
    return {
      OfficeID:'',
      collapseHtml:'',
      detailHtml:'',
      crumbList:[
          {
              name:'Information',
              url:''
          }
      ],
      headerTitle:'Information',
      openKeys: ['1'],
      selectKeys:['1.1'],
      selectedKeys:[],
      customStyle:'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      textt:'<span>123</span>',
      informationData:[],
      rootSubmenuKeys:[],
      isCollapse:false
    };
  },
  props: {},
  watch: {
    '$route' (to, from) {
          // data数据操作
          console.log(to)
          console.log(from)
          this.$store.state.loadding = true
          let menud = this.subCheckData(this.informationData,to.query.key2,to.query.key1)
          this.informationHtml(menud)
    },
    openKeys(val) {
      console.log('openKeys', val);
    },
    selectKeys(val){
      console.log('selectKeys',val)
      this.selectedKeys = val
    }
  },
  methods: {
    changeActivekey(key){
      console.log(key)
      if(key){
        this.$Ajax.get(this.collapesList[key].fileText)
        .then( (response)=> {
            this.collapesList[key].htmlMsg = response.data
            this.collapseHtml = response.data
        })
        .catch( (error) =>{
            console.log(error);
        });
      }
      
    },
    onOpenChange(openKeys) {
      console.log(openKeys)
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    handleClick(e) {
      console.log('click ', e);
      let newData = this.informationData
      let menud = ''
      if(e.keyPath.length >=3){
        // 三级菜单
        menud = this.subCheckData(newData,e.keyPath[0],e.keyPath[1],e.keyPath[2])
      }else if(e.keyPath.length == 1){
        // 三级菜单
        menud = this.subCheckData(newData,e.keyPath[0])
      }else{
        menud = this.subCheckData(newData,e.keyPath[0],e.keyPath[1])
      }
      this.informationHtml(menud)
    },
    
    // key1 点击元素 key2 展开栏 key3 展开栏
    subCheckData(newData,key1,key2,key3){
      console.log(newData)
      let list = []
      let d = {}
      
      console.log(list)
      if(key3 && key2 && key1){
        let newList = []
        for(let i=0;i<newData.length;i++){
          // 第一层for
          if(newData[i].key == key3){
            let list1 = newData[i].childrens

            for(let i1=0;i1<list1.length;i1++){
              // 第二层for
              if(list1[i1].key == key2){
                let newList1 = list1[i1].childrens

                for(let i2=0;i2<newList1.length;i2++){
                  // 第三层for
                  if(newList1[i2].key == key1){
                    d = newList1[i2]
                    break
                  }
                }
                break
              }
            }
            break
          }
        }
        
      }else if(key2 && key1){
        this.openKeys = [key2]
        this.selectKeys  = [key1]
        for(let i=0;i<newData.length;i++){
          if(newData[i].key == key2){
            list = newData[i].childrens
            break
          }
        }
        for(let i=0;i<list.length;i++){
          if(list[i].key == key1){
            d = list[i]
            break
          }
        }
      }else{
        this.openKeys = [key1]
        this.selectKeys  = [key1]
        for(let i=0;i<newData.length;i++){
          if(newData[i].key == key1){
            d = newData[i]
            break
          }
        }
      }
      console.log(d)
      return d
    },
    informationHtml(menud){
      console.log(menud)
      if(menud.childrens.length>1){
        // 多条数据 手风琴展示样式
        this.isCollapse = true
        this.collapesList = menud.childrens
      }else{
        if(menud.childrens.length == 0) return
        var that = this
        this.isCollapse = false
        console.log(menud.childrens[0].fileText)
        if(menud.childrens[0].isLink == "Y") {
          window.location.href = menud.childrens[0].linkUrl
        } else {
          this.$Ajax.get(menud.childrens[0].fileText)
          .then( (response)=> {
              console.log(response.data)
              this.detailHtml = response.data
              this.informationData = this.informationData
          })
          .catch( (error) =>{
              console.log(error);
          });
        }
        
      }
      
    },
    dataFilter(data){
      let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
      console.log(data,'---')
      debugger
      data[0].childrens.forEach((i,k)=>{
        console.log(i)
        if(i.officeIdStr && i.officeIdStr.indexOf(OfficeID) == -1){
          i.splice(k, 1); 
        }else{
          i.childrens||[].forEach((j,e)=>{
            if(j.officeIdStr && j.officeIdStr.indexOf(OfficeID) == -1){
              j.splice(e, 1); 
            }
          })
        }
      })
      console.log(data[0].childrens)
    },
    filtersAjax(value){
      debugger
      this.$Ajax.get(value)
      .then( (response)=> {
          return response.data
      })
      .catch( (error) =>{
          console.log(error);
      });
    },
    filtersText(value) {
      let html = ''
      if (!value) return ''
      debugger
      this.$Ajax.get(value)
      .then( (response)=> {
          value = response.data
      })
      .catch( (error) =>{
          console.log(error);
      });
      return value
    },
    checkdata(detailObjs){
      debugger
      let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
      this.OfficeID = OfficeID
      var returnDetailObjs = detailObjs.concat();

        for (var i = 0; i < returnDetailObjs.length; i++) {
            if(returnDetailObjs[i].officeIdStr){
              if(returnDetailObjs[i].officeIdStr.indexOf(OfficeID) == -1){
                returnDetailObjs.splice(i, 1);
              }else{

                if(returnDetailObjs[i].childrens){
                  for(var j=0;j<returnDetailObjs[i].childrens.length;j++){
                    if(returnDetailObjs[i].childrens[j].officeIdStr){
                      if(returnDetailObjs[i].childrens[j].officeIdStr.indexOf(OfficeID) == -1){
                        returnDetailObjs[i].childrens.splice(j, 1);
                      }else{

                        if(returnDetailObjs[i].childrens[j].childrens){
                          
                          for(var k = 0;k<returnDetailObjs[i].childrens[j].childrens.length;k++){
                            if(returnDetailObjs[i].childrens[j].childrens[k].officeIdStr){
                              if(returnDetailObjs[i].childrens[j].childrens[k].officeIdStr.indexOf(OfficeID) == -1){
                                returnDetailObjs[i].childrens[j].childrens.splice(k, 1);
                              }else{
                                returnDetailObjs[i].childrens[j].childrens.splice(k, 1);
                              }
                            }
                          }
                        }
                      }
                    }else{
                      // 值null全部处理
                      returnDetailObjs[i].childrens.splice(j, 1);
                    }
                  }
                }
              }
            }else{
              // 值null全部处理
              returnDetailObjs.splice(i, 1);
            }
            
        }
        return returnDetailObjs;
    }
  },
  filters: {
    
  },
  computed: {},
  created() {
    
    // let informationlist = []
    // NAVJSON[0].childrens.forEach((i)=>{
    //   if(i.nodeTitle == 'Information'){
    //     informationlist.push(i)
    //   }
    // })
    let infoData = this.$Utils.getSession('informationData')
    // let newdata = this.checkdata(informationlist[0].childrens)

    // informationlist[0].childrens = newdata
    // 站点数据筛选
    // this.dataFilter(informationlist)
    let rootSubmenuKeys = []
    infoData[0].childrens.forEach((i,k)=>{
        i.key = `${k+1}`
        console.log(i.key)
        rootSubmenuKeys.push(`${k+1}`)
        if(i.childrens) {
          i.childrens.forEach((j,key)=>{
              j.key = `${k+1}.${key+1}`
              if(j.childrens){
                j.childrens.forEach((m,y)=>{
                  m.key = `${k+1}.${key+1}.${y+1}`
                })
              }
          })
        }
        
    })
    
    this.rootSubmenuKeys = rootSubmenuKeys
    
    this.informationData = infoData[0].childrens
    

    
    let menud = this.subCheckData(infoData[0].childrens,this.$route.query.key2,this.$route.query.key1)
    console.log(menud)
    this.informationHtml(menud)
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  
</style>
